// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newsletter-signup":"newsletter-signup_IxDFd"};